import React from 'react';
import { Card, Row, Col } from 'antd';
import { Bar, Pie } from '@ant-design/charts';

const ApiUsage = ({ data, loading }) => {
  const { top_endpoints = [], method_distribution = [] } = data || {};

  const total = method_distribution.reduce((sum, d) => sum + (d.count || 0), 0);

  const barConfig = {
    data: top_endpoints,
    xField: 'count',
    yField: 'endpoint',
    seriesField: 'endpoint',
    legend: { position: 'top-left' },
  };

  const pieConfig = {
    appendPadding: 10,
    data: method_distribution,
    angleField: 'count',
    colorField: 'method',
    radius: 0.9,
    label: {
      text: 'value',
      style: {
        fontWeight: 'bold',
      },
    },
    interactions: [{ type: 'element-active' }],
  };

  return (
    <Card title="API Usage" loading={loading}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <h4>Top 10 API Endpoints</h4>
          {top_endpoints.length > 0 ? <Bar {...barConfig} /> : <p>No data</p>}
        </Col>
      </Row>
    </Card>
  );
};

export default ApiUsage;